import { initModule as initLoader } from "./Loader";

export { initLoader };

export default {
  initLoader: initLoader
}
